import { mediaQuery } from './media-query';

jQuery(document).ready(() => {

    mediaQuery(
      'max',
      'width',
      '767',
      () => {
        // Mobile do anything
        ulToSelect();
      }
    );
    mediaQuery(
        'min',
        'width',
        '768',
        () => {
          // Mobile do anything
          holesList();
        }
      );
  
});

closeAlert();

/** Close promoción fases alert in mobile */
function closeAlert() {
    let alerta = jQuery('.alerta');
    let close = jQuery('.alerta .close');

    close.on('click', function(){
        alerta.fadeOut("slow");
    });
}

/** Ul to Select en Olivanova Golf */
function ulToSelect() {
    jQuery(".select").on('click', function() {
        let is_open = jQuery(this).hasClass("open");
        if (is_open) {
          jQuery(this).removeClass("open");
        } else {
          jQuery(this).addClass("open");
        }
    });

    jQuery('.select li a').on('click', function(e){
        e.preventDefault();
        jQuery('.select li').hide();
        jQuery(this).parent('li').css('display', 'block');
        let imagen = jQuery(this).attr("href"); 
        jQuery(".img-hole").css("display","none");  
        console.log(imagen);
        jQuery(imagen).css("display","block");
    })
      
    jQuery(document).mouseup(function(event) {      
        let target = event.target;
        let select = jQuery(".select");
      
        if (!select.is(target) && select.has(target).length === 0) {
          select.removeClass("open");
        }      
    });
}

function holesList(){
    // jQuery('.select li a').on('click', function(e){
    //     e.preventDefault();
    //     jQuery('.select li').removeClass('active');
    //     jQuery(this).parent('li').addClass('active');
    //     let imagen = jQuery(this).attr("href"); 
    //     jQuery(".img-hole").css("display","none");  
    //     console.log(imagen);
    //     jQuery(imagen).css("display","block");
    // })
    jQuery('.select li').on('click', function(e){
        e.preventDefault();
        jQuery('.select li').removeClass('active');
        jQuery(this).addClass('active');
        let imagen = jQuery(this).find('a').attr("href"); 
        jQuery(".img-hole").css("display","none");  
        console.log(imagen);
        jQuery(imagen).css("display","block");
    })
}